export const billingApiActionTypes = {
  resetBillings: 'RESET_BILLINGS',

  readBillingsRequest: 'READ_BILLINGS_REQUEST',
  readBillingsSuccess: 'READ_BILLINGS_SUCCESS',
  readBillingsFailure: 'READ_BILLINGS_FAILURE',
}
